export function time() {
  const time = document.querySelector('.js-time-el');
  if (time) {
    function updateTime() {
      const now = new Date();
      time.textContent = now.toLocaleTimeString();
    }
    updateTime();
    setInterval(updateTime, 1000);
  }  
}